import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route} from 'react-router';
import {Navigate} from 'react-router-dom';

import Home from './home';

import SignOut from './auth/Signout';

import Playbooks from './playbooks/Playbooks';
import Skills from './skills/Skills';
import CasePage from './case/CasePage';
import CaseMonitorPage from './case/CaseMonitorPage';
import InboxPage from './inbox/InboxPage';
import DomainGuideList from './domain_guide/DomainGuideList';
import DomainGuideView from './domain_guide/DomainGuideView';

import MyDay from './tasks/MyDay';
import AllTasks from './tasks/AllTasks';

import CaregiverList from './caregiver/CaregiverList';
import LoomCaregiverList from './caregiver/LoomCaregiverList';
import LoomCaregiverView from './caregiver/LoomCaregiverView';
import CaregiverNew from './caregiver/CaregiverNew';
import CaregiverView from './caregiver/CaregiverView';

import ClientList from './client/ClientList';
import ClientNew from './client/ClientNew';
import ClientView from './client/ClientView';
import LoomClientList from './client/LoomClientList';
import LoomClientView from './client/LoomClientView';

import ClientLeadList from './client_lead/ClientLeadList';

import LoomLeadList from './loom_lead/LoomLeadList';
import LoomLeadView from './loom_lead/LoomLeadView';

import ManageUser from './admin/user/ManageUser';

import CaregiverScheduleDashboardPage from './schedule/CaregiverScheduleDashboardPage';
import ClientScheduleDashboardPage from './schedule/ClientScheduleDashboardPage';

import EventDetailPage from './schedule/EventDetailPage';
import LoomClientScheduleDashboardPage from './schedule/LoomClientScheduleDashboardPage';
import LoomCaregiverScheduleDashboardPage from './schedule/LoomCaregiverScheduleDashboardPage';
import LoomEventDetailPage from './schedule/LoomEventDetailPage';

import CareerDashboard from './career/CareerDashboard';
import CreateJob from './career/JobCreation';
import EditJob from './career/JobEdit';
import JobView from './career/JobView';
import LoomCareerDashboard from './career/LoomCareerDashboard';
import LoomJobView from './career/LoomJobView';
import LeadFunnelPage from './metrics/LeadFunnel';
import ClientMetricsPage from './metrics/ClientMetrics';
import AgentReportCardPage from './metrics/AgentReportCard';
import AgentChat from './agent/AgentChat';
import SituationSource from './source/SituationSource';
import Routines from './routines/Routines';
import BulkMessaging from './bulk_messaging/BulkMessaging';

const Router = () => {
  return (
    <Routes>
      <Route path="/" Component={Home} />

      <Route path="/signout" Component={SignOut} />

      <Route path="/admin/user" Component={ManageUser} />
      <Route path="/admin/user/new" Component={ManageUser} />
      <Route path="/admin/user/:userRn/deactivate" Component={ManageUser} />

      <Route path="/playbooks" Component={Playbooks} />
      <Route path="/skills" Component={Skills} />
      <Route path="/cases" element={<Navigate to="/case-monitor" replace />} />
      <Route path="/case/:caseRn" Component={CasePage} />
      <Route path="/case-monitor" Component={CaseMonitorPage} />
      <Route path="/inbox" Component={InboxPage} />
      <Route path="/inbox/:conversationRn" Component={InboxPage} />
      <Route path="/domain-guides" Component={DomainGuideList} />
      <Route path="/domain-guide/:domainGuideRn" Component={DomainGuideView} />

      <Route path="/tasks/my-day" Component={MyDay}/>
      <Route path="/tasks/all-tasks" Component={AllTasks}/>

      <Route path="/caregiver" Component={CaregiverList} />
      <Route path="/caregiver-loom" Component={LoomCaregiverList} />
      <Route path="/caregiver-loom/:caregiverId" Component={LoomCaregiverView} />
      <Route path="/caregiver/new" Component={CaregiverNew} />
      <Route path="/caregiver/:caregiverRn" Component={CaregiverView} />

      <Route path="/client" Component={ClientList} />
      <Route path="/client/new" Component={ClientNew} />
      <Route path="/client/loom" Component={LoomClientList} />
      <Route path="/client/loom/:clientRn" Component={LoomClientView} />
      <Route path="/client/:clientRn" Component={ClientView} />

      <Route path="/client_lead" Component={ClientLeadList} />

      <Route path="/loom_lead" Component={LoomLeadList} />
      <Route path="/loom_lead/:clientId" Component={LoomLeadView} />

      <Route path="/metrics/lead-funnel" Component={LeadFunnelPage} />
      <Route path="/metrics/clients" Component={ClientMetricsPage} />
      <Route path="/metrics/agent-report-card" Component={AgentReportCardPage} />

      <Route path="/agent/chat" Component={AgentChat} />
      <Route path="/source/situation" Component={SituationSource} />
      <Route path="/agent/routines" Component={Routines} />
      <Route path="/bulk-messaging" Component={BulkMessaging} />

      <Route path="/schedule/client" Component={ClientScheduleDashboardPage} />
      <Route path="/schedule/client/loom" Component={LoomClientScheduleDashboardPage} />
      <Route path="/schedule/caregiver" Component={CaregiverScheduleDashboardPage} />
      <Route path="/schedule/caregiver/loom" Component={LoomCaregiverScheduleDashboardPage} />
      <Route path="/schedule/event/loom/:eventRn" Component={LoomEventDetailPage} />
      <Route path="/schedule/event/:eventRn" Component={EventDetailPage} />

      <Route path="/career" Component={CareerDashboard} />
      <Route path="/career/create" Component={CreateJob} />
      <Route path="/career/loom" Component={LoomCareerDashboard} />
      <Route path="/career/loom/:jobRn" Component={LoomJobView} />
      <Route path="/career/:jobRn" Component={JobView} />
      <Route path ="/career/:jobRn/edit" Component={EditJob} />

    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

